
export function Footer() {
  return (
    <footer className="bg-black/40 backdrop-blur-sm border-t border-white/5 py-12 sm:py-16 mt-8">
      <div className="container mx-auto text-center">
        <p className="text-sm text-white">© 2023 PREPT. All rights reserved.</p>
        <div className="flex justify-center space-x-4 mt-2">
          <a href="/privacy-policy" className="text-white hover:underline">Privacy Policy</a>
          <a href="/terms" className="text-white hover:underline">Terms of Service</a>
          <a href="/help" className="text-white hover:underline">Help</a>
          <a href="https://instagram.com/preptcine" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Instagram</a>
        </div>
      </div>
    </footer>
  );
}
